"use strict";
/**
 * Row apply / update actions bound onto AudRoam $scope.
 * Extracted from AudRoamCtrl so time-adjust + field patches stay testable
 * without the full controller.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerRowApplyScopeActions = exports.createReapplyRememberedLocalPatches = exports.createPatchLocalRowsById = exports.createApplyAction = exports.createUpdateRowArray = void 0;
var rowSplitScopeActions_1 = require("./rowSplitScopeActions");
var localRowPatch_1 = require("./localRowPatch");
function createUpdateRowArray(host, deps) {
    var personService = deps.personService, $timeout = deps.$timeout;
    return function updateRowArray(row, callback) {
        if (row.edit) {
            row.uiMessage = 'saving edits...';
            personService
                .updateResultRow(row)
                .then(function (response) {
                if (response.data.Result === 'OK') {
                    row.edit = null;
                    host.editingRow = null;
                    proceedWithAction();
                }
                else {
                    row.uiMessage =
                        'Error saving edits: ' + (response.data.Message || 'Unknown error');
                }
            })
                .catch(function (error) {
                row.uiMessage = 'Error saving edits';
                console.error('Error saving edits:', error);
            });
        }
        else {
            proceedWithAction();
        }
        function proceedWithAction() {
            row.uiMessage = '...';
            personService
                .updateResultRow(row)
                .then(function (response) {
                var _a, _b;
                var ok = response && response.data && response.data.Result === 'OK';
                var res = response && response.data ? response.data : {};
                row.uiMessage = ok ? 'OK' : res.Result || 'ERROR';
                try {
                    if (row && row.rowArray && row.rowArray.__closeAtNextStamp) {
                        if (ok) {
                            var when = res.CompletedUTC ? ' (' + res.CompletedUTC + ')' : '';
                            if (host.viewMode) {
                                host.viewMode.Message = 'End time set from next newer' + when;
                            }
                            try {
                                (_a = host.toast) === null || _a === void 0 ? void 0 : _a.call(host, 'End time set from next newer' + when, 'success', 4000);
                            }
                            catch (_c) { }
                            $timeout(function () {
                                if (host.viewMode) {
                                    host.viewMode.Message = 'OK';
                                }
                            }, 2000);
                        }
                        else {
                            var msg = res.Message ? ': ' + res.Message : '';
                            if (host.viewMode) {
                                host.viewMode.Message = 'Could not set end' + msg;
                            }
                            try {
                                (_b = host.toast) === null || _b === void 0 ? void 0 : _b.call(host, 'Could not set end' + msg, 'danger', 5000);
                            }
                            catch (_d) { }
                            $timeout(function () {
                                if (host.viewMode) {
                                    host.viewMode.Message = 'OK';
                                }
                            }, 3000);
                        }
                    }
                }
                catch (_e) { }
            })
                .then(function () {
                if (callback) {
                    callback();
                }
            });
        }
    };
}
exports.createUpdateRowArray = createUpdateRowArray;
function createApplyAction(host, deps) {
    var personService = deps.personService, pilotNotesSyncService = deps.pilotNotesSyncService, $timeout = deps.$timeout;
    return function applyAction(row, actionSpec, callback) {
        (0, rowSplitScopeActions_1.saveChangesAndProceed)(host, row, function () {
            var isTimeAdjust = actionSpec &&
                (actionSpec.setToNow ||
                    actionSpec.backdateMinute !== undefined ||
                    actionSpec.closeAtNextStamp);
            if (isTimeAdjust) {
                row.uiMessage = '...';
                pilotNotesSyncService
                    .setTime(row.ID, {
                    setToNow: !!actionSpec.setToNow,
                    backdateMinutes: actionSpec.backdateMinute,
                    endFromNext: !!actionSpec.closeAtNextStamp,
                })
                    .then(function (res) {
                    var _a, _b, _c, _d;
                    row.uiMessage = 'OK';
                    var patch = (0, localRowPatch_1.patchFromSetTimeResponse)(res);
                    if (actionSpec.closeAtNextStamp && patch.pnCompletedUTC == null && res) {
                        // ensure completion fields for end-from-next even if snapshot sparse
                        if (res.CompletedUTC) {
                            patch.pnCompletedUTC = res.CompletedUTC;
                        }
                    }
                    // Instant feedback: primary row + all list copies + open timer meta
                    if (Object.keys(patch).length) {
                        if (host.patchLocalRowsById) {
                            host.patchLocalRowsById(row.ID, patch, row);
                        }
                        else {
                            (0, localRowPatch_1.applyPatchToRow)(row, patch);
                        }
                    }
                    // Backdate may shrink the adjacent older recent row's end
                    try {
                        var adj = res && res.adjacent;
                        if (adj && adj.ID != null) {
                            var adjPatch = (0, localRowPatch_1.patchFromSetTimeResponse)({
                                pnCustomTimeUTC: adj.pnCustomTimeUTC,
                                pnCompletedUTC: (_a = adj.pnCompletedUTC) !== null && _a !== void 0 ? _a : adj.CompletedUTC,
                                CompletedUTC: (_b = adj.CompletedUTC) !== null && _b !== void 0 ? _b : adj.pnCompletedUTC,
                                row: adj,
                                mode: 'end_from_next',
                            });
                            if (adj.pnTopicDetail != null) {
                                adjPatch.pnTopicDetail = adj.pnTopicDetail;
                            }
                            if (adj.pnSchedule != null) {
                                adjPatch.pnSchedule = adj.pnSchedule;
                            }
                            if (host.patchLocalRowsById) {
                                host.patchLocalRowsById(adj.ID, adjPatch);
                            }
                            else {
                                // Best-effort: only primary lists on host
                                (0, localRowPatch_1.patchRowsByIdInLists)([host.recentRows, host.teamRecent, host.reportResult], adj.ID, adjPatch);
                            }
                        }
                    }
                    catch (_e) { }
                    var toastMsg = res && res.Message ? res.Message : 'Time updated';
                    if (actionSpec.setToNow) {
                        toastMsg = 'Time set to now';
                    }
                    else if (actionSpec.backdateMinute !== undefined) {
                        var adjId = res && res.adjacent_id != null ? res.adjacent_id : null;
                        toastMsg =
                            'Backdated ' +
                                actionSpec.backdateMinute +
                                'm' +
                                (adjId != null ? ' (shrunk adjacent #' + adjId + ')' : '');
                    }
                    else if (actionSpec.closeAtNextStamp) {
                        var when = res && res.CompletedUTC ? ' (' + res.CompletedUTC + ')' : '';
                        toastMsg = 'End time set from next newer' + when;
                    }
                    try {
                        (_c = host.toast) === null || _c === void 0 ? void 0 : _c.call(host, toastMsg, 'success', 4000);
                    }
                    catch (_f) { }
                    if (actionSpec.closeAtNextStamp && host.viewMode) {
                        host.viewMode.Message = toastMsg;
                        $timeout(function () {
                            if (host.viewMode) {
                                host.viewMode.Message = 'OK';
                            }
                        }, 2000);
                    }
                    // Peers need the patched Recent + openMeta immediately —
                    // PHP recent can still be stale after Python set-time.
                    try {
                        (_d = host.publishFocusRecentDigestFromLocal) === null || _d === void 0 ? void 0 : _d.call(host, actionSpec.backdateMinute !== undefined
                            ? 'backdate'
                            : actionSpec.setToNow
                                ? 'set_to_now'
                                : 'set_time');
                    }
                    catch (_g) { }
                })
                    .catch(function (err) {
                    var _a;
                    var msg = (err && err.message) ||
                        (err && err.data && err.data.Message) ||
                        'Set time failed';
                    row.uiMessage = 'ERROR';
                    try {
                        (_a = host.toast) === null || _a === void 0 ? void 0 : _a.call(host, msg, 'danger', 6000);
                    }
                    catch (_b) { }
                    if (actionSpec.closeAtNextStamp && host.viewMode) {
                        host.viewMode.Message = 'Could not set end: ' + msg;
                        $timeout(function () {
                            if (host.viewMode) {
                                host.viewMode.Message = 'OK';
                            }
                        }, 3000);
                    }
                })
                    .then(function () {
                    if (callback) {
                        callback();
                    }
                });
                return;
            }
            // Intentional field patches (billable / invoice / service level / tags)
            // go through Python /fields — not PHP rowArray (time flags only on allowlist).
            if (actionSpec.updateFields && Object.keys(actionSpec.updateFields).length) {
                row.uiMessage = '...';
                pilotNotesSyncService
                    .patchFields(row.ID, __assign({}, actionSpec.updateFields))
                    .then(function (res) {
                    var _a;
                    row.uiMessage = 'OK';
                    var applied = (res && res.applied && typeof res.applied === 'object'
                        ? res.applied
                        : actionSpec.updateFields) || {};
                    if (host.patchLocalRowsById) {
                        host.patchLocalRowsById(row.ID, __assign({}, applied), row);
                    }
                    else {
                        (0, localRowPatch_1.applyPatchToRow)(row, applied);
                    }
                    var toastMsg = res && res.Message ? String(res.Message) : 'Updated';
                    if (Object.prototype.hasOwnProperty.call(applied, 'pnFlowKind')) {
                        var fk = applied.pnFlowKind;
                        toastMsg =
                            fk == null || fk === ''
                                ? 'Flow stamp cleared'
                                : "flowKind \u2192 ".concat(fk, " (time-tracking)");
                    }
                    else if (applied.pnInvoiceNote != null) {
                        toastMsg = 'Invoice: ' + applied.pnInvoiceNote;
                    }
                    else if (Object.prototype.hasOwnProperty.call(applied, 'pnAssetTag') &&
                        (applied.pnAssetTag == null || applied.pnAssetTag === '')) {
                        toastMsg = 'Asset link removed';
                    }
                    else if (applied.service_level_fk != null) {
                        toastMsg = 'Service level: ' + applied.service_level_fk;
                    }
                    else if (applied.pnTopicGroup != null) {
                        toastMsg = 'Topic: ' + applied.pnTopicGroup;
                    }
                    try {
                        (_a = host.toast) === null || _a === void 0 ? void 0 : _a.call(host, toastMsg, 'success', 3500);
                    }
                    catch (_b) { }
                })
                    .catch(function (err) {
                    var _a;
                    var msg = (err && err.message) || 'Field update failed';
                    row.uiMessage = 'ERROR';
                    try {
                        (_a = host.toast) === null || _a === void 0 ? void 0 : _a.call(host, msg, 'danger', 5000);
                    }
                    catch (_b) { }
                })
                    .then(function () {
                    if (callback) {
                        callback();
                    }
                });
                return;
            }
            row.uiMessage = '...';
            var rowArray = { ID: row.ID };
            if (actionSpec.applyAutoEnd) {
                rowArray.__applyAutoEnd = true;
            }
            else if (actionSpec.clearAutoEnd) {
                rowArray.__clearAutoEnd = true;
            }
            else if (actionSpec.clearCompleted) {
                rowArray.__clearCompleted = true;
            }
            else {
                // Legacy: unknown actionSpec keys — still blocked by allowlist if non-flag
                Object.assign(rowArray, actionSpec);
            }
            row.rowArray = rowArray;
            personService
                .updateResultRow(row)
                .then(function (response) {
                var _a;
                var ok = response && response.data && response.data.Result === 'OK';
                var res = response && response.data ? response.data : {};
                row.uiMessage = ok ? 'OK' : res.Result || 'ERROR';
                if (!ok) {
                    try {
                        (_a = host.toast) === null || _a === void 0 ? void 0 : _a.call(host, res.Message || res.Result || 'Update failed', 'danger', 5000);
                    }
                    catch (_b) { }
                }
            })
                .catch(function (err) {
                var _a;
                var msg = (err && err.message) ||
                    (err && err.name === 'FieldAllowlistError' && err.message) ||
                    'Update failed';
                row.uiMessage = 'ERROR';
                try {
                    (_a = host.toast) === null || _a === void 0 ? void 0 : _a.call(host, String(msg), 'danger', 5000);
                }
                catch (_b) { }
            })
                .then(function () {
                if (callback) {
                    callback();
                }
            });
        });
    };
}
exports.createApplyAction = createApplyAction;
/**
 * Patch every local UI copy of a row (recent / team / search / primary)
 * and keep open/session timer meta ticking from the new start (or idle if closed).
 */
function createPatchLocalRowsById(host, memory) {
    return function patchLocalRowsById(rowId, patch, primaryRow) {
        memory === null || memory === void 0 ? void 0 : memory.remember(rowId, patch);
        if (primaryRow) {
            (0, localRowPatch_1.applyPatchToRow)(primaryRow, patch);
        }
        var lists = [host.recentRows, host.teamRecent, host.reportResult];
        // Avoid double-patching primary if it already sits in a list
        var count = (0, localRowPatch_1.patchRowsByIdInLists)(lists, rowId, patch);
        if (primaryRow && Number(primaryRow.ID) === Number(rowId)) {
            // primary already patched; lists may have re-patched same refs (ok) or distinct copies
            count = Math.max(count, 1);
        }
        if (host.editingRow && Number(host.editingRow.ID) === Number(rowId) && host.editingRow !== primaryRow) {
            (0, localRowPatch_1.applyPatchToRow)(host.editingRow, patch);
            count += 1;
        }
        var nowMs = Date.now();
        var openSync = (0, localRowPatch_1.syncOpenTimerMeta)(host.openMeta, rowId, patch, nowMs);
        host.openMeta = openSync.meta;
        var sessionSync = (0, localRowPatch_1.syncOpenTimerMeta)(host.sessionMeta, rowId, patch, nowMs);
        host.sessionMeta = sessionSync.meta;
        if ((openSync.resetTickBase || sessionSync.resetTickBase) && host.viewMode) {
            // Live duration formula adds (now - recentGeneratedAtMs); reset so openForSec is exact.
            host.viewMode.recentGeneratedAtMs = nowMs;
            host.viewMode.recentLastAt = nowMs;
        }
        return count;
    };
}
exports.createPatchLocalRowsById = createPatchLocalRowsById;
function createReapplyRememberedLocalPatches(host, memory) {
    return function reapplyRememberedLocalPatches() {
        var lists = [host.recentRows, host.teamRecent, host.reportResult];
        var count = memory.reapplyToLists(lists);
        // Re-sync timer meta from any remembered open-row patch
        var nowMs = Date.now();
        var resetTick = false;
        for (var _i = 0, _a = memory.activeEntries(nowMs); _i < _a.length; _i++) {
            var _b = _a[_i], rowId = _b.rowId, patch = _b.patch;
            var openSync = (0, localRowPatch_1.syncOpenTimerMeta)(host.openMeta, rowId, patch, nowMs);
            host.openMeta = openSync.meta;
            resetTick = resetTick || openSync.resetTickBase;
            var sessionSync = (0, localRowPatch_1.syncOpenTimerMeta)(host.sessionMeta, rowId, patch, nowMs);
            host.sessionMeta = sessionSync.meta;
            resetTick = resetTick || sessionSync.resetTickBase;
        }
        if (resetTick && host.viewMode) {
            host.viewMode.recentGeneratedAtMs = nowMs;
            host.viewMode.recentLastAt = nowMs;
        }
        return count;
    };
}
exports.createReapplyRememberedLocalPatches = createReapplyRememberedLocalPatches;
function registerRowApplyScopeActions($scope, personService, pilotNotesSyncService, $timeout) {
    var deps = { personService: personService, pilotNotesSyncService: pilotNotesSyncService, $timeout: $timeout };
    var host = $scope;
    var memory = new localRowPatch_1.LocalRowPatchMemory();
    host.patchLocalRowsById = createPatchLocalRowsById(host, memory);
    host.reapplyRememberedLocalPatches = createReapplyRememberedLocalPatches(host, memory);
    $scope.updateRowArray = createUpdateRowArray(host, deps);
    $scope.applyAction = createApplyAction(host, deps);
    $scope.patchLocalRowsById = host.patchLocalRowsById;
    $scope.reapplyRememberedLocalPatches = host.reapplyRememberedLocalPatches;
}
exports.registerRowApplyScopeActions = registerRowApplyScopeActions;
